export default {"src":"/_next/static/media/owner-operated.f8213875.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};